import { PureComponent, ReactNode } from 'react';
import { KeyToSetObject } from '../Chart';
import { Checkbox } from 'antd';

interface Props {
    tooth: string;
    isSelected: boolean;
    isForLowerTeeth?: boolean;
    selectedMultiTeeth: KeyToSetObject;
    selectMultiTeeth: (teeth: string, surface?: number) => void;
    isSelectedMultiTeethArray: boolean;
}

class ToothNumber extends PureComponent<Props> {
    render(): ReactNode {
        const {
            tooth,
            isSelected,
            isForLowerTeeth,
            selectedMultiTeeth,
            selectMultiTeeth,
            isSelectedMultiTeethArray,
        } = this.props;
        const isToothSelected = isSelected && !isSelectedMultiTeethArray;
        const isCheckBoxVisible = Boolean(selectedMultiTeeth[tooth] || isSelectedMultiTeethArray);

        return (
            <p
                className={`relative text-12 h-28 w-28 flex items-center justify-center font-700 rounded-full ${
                    isToothSelected ? 'text-white bg-darwin-accent-bright-blue-800' : ''
                } ${isForLowerTeeth ? 'mb-3' : 'mt-3'} overflow-hidden tooth-number`}
            >
                <span>{tooth}</span>
                <p
                    className={`absolute h-full w-full inset-0 ${
                        isCheckBoxVisible ? 'visible' : 'hidden'
                    } rounded-full`}
                >
                    <p className="h-full w-full flex items-center justify-center">
                        <Checkbox
                            checked={Boolean(selectedMultiTeeth[tooth])}
                            onChange={() => selectMultiTeeth(tooth)}
                        />
                    </p>
                </p>
            </p>
        );
    }
}

export default ToothNumber;
